module.exports = __webpack_public_path__ + "img/img_shouye_zijin_two@2x.48e6a420.png";